import React from 'react';
import styled from 'styled-components';
import commentIcon from '../../../images/comment.svg';

const CommentButton = styled.button`
	background: transparent;
	border: none;
	border-radius: 0;
	width: 40px;
	height: 30px;
	padding: 0;
	cursor: pointer;

	&:hover,
	&:focus {
		opacity: 0.7;
	}
`;

class CommentToggleButton extends React.Component {
	render() {
		return (
			<CommentButton onClick={this.props.onClick} type="button">
				<img src={commentIcon} alt="Comment icon" />
			</CommentButton>
		);
	}
}

export default CommentToggleButton;



// WEBPACK FOOTER //
// ./src/components/Common/CommentToggleButton/CommentToggleButton.js